import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class WaterTankService {

  constructor(private http: HttpClient,private env: EnvService) { }

   getAll():Observable <any[]> {
    return this.http.get<any[]>(`${this.env.apiUrl}/water-tank`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    create(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/water-tank`,  data)
        .pipe(catchError(this.handleError));
       
    }


    delete(id: number) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/water-tank/${id}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }


}
